import { render, staticRenderFns } from "./commoditySticker.vue?vue&type=template&id=6a4dbd16&scoped=true"
import script from "./commoditySticker.vue?vue&type=script&lang=js"
export * from "./commoditySticker.vue?vue&type=script&lang=js"
import style0 from "./commoditySticker.vue?vue&type=style&index=0&id=6a4dbd16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4dbd16",
  null
  
)

export default component.exports